export const TEAMS = {
    GROWTH: "Growth",
    LYNX: "Lynx",
    HAWKS: "Hawks",
} as const;
